import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { SlipProvider } from "./context/SlipContext";
import { WatchProvider } from "./context/WatchContext";
import { SportProvider } from "./context/SportContext";
import { Navbar } from "./components/Navbar";
import { LiveScores } from "./components/LiveScores";
import { BetSlip } from "./components/BetSlip";
import Dashboard from "./pages/Dashboard";
import TeamRankings from "./pages/TeamRankings";
import Results from "./pages/Results";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PlayerPage from "./pages/PlayerPage";

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <SlipProvider>
            <WatchProvider>
              <SportProvider>
                <Navbar />
                <LiveScores />
                <BetSlip />
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/rankings" element={<TeamRankings />} />
                  <Route path="/results" element={<Results />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/player/:playerId" element={<PlayerPage />} />
                </Routes>
                <Toaster position="top-center" theme="dark" richColors />
              </SportProvider>
            </WatchProvider>
          </SlipProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
